import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Header from "components/Header/Header.js";
import PageFooter from "components/Footer/PageFooter.js";
import HeaderLinks from "components/Header/PageHeaderLinks.js";
import landingPageStyle from "assets/jss/material-kit-pro-react/Pages/landingPageStyle.js";

// Sections for this page
import SectionProduct from "./Sections/SectionProduct.js";
import SectionBenefits from "./Sections/SectionBenefits.js";
import SectionSolution from "./Sections/SectionSolution.js";
import SectionApplications from "./Sections/SectionApplications.js";
import SectionTreinamento from "./Sections/SectionTreinamento.js";
import SectionQuestions from "./Sections/SectionQuestions.js";
import SectionPartners from "./Sections/SectionPartners.js";
import "assets/css/homeVideo.css";

import TagManager from "react-gtm-module";
// Animações
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

const useStyles = makeStyles(landingPageStyle);

export default function LandingPage({ ...rest }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });

  TagManager.dataLayer({
    dataLayer: {
      path: "/",
      page: "landpage",
    },
    dataLayerName: "PageView",
  });

  const classes = useStyles();
  return (
    <div>
      <Header
        color="white"
        brand="EyeFlow.AI"
        links={<HeaderLinks dropdownHoverColor="info" />}
        displayImage="block"
        fixed
        changeColorOnScroll={{
          height: 300,
          color: "white",
        }}
        {...rest}
      />
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
          marginTop: "155px",
        }}
        className={classNames(classes.main)}
      >
        <SectionProduct />
        <SectionBenefits />
        <SectionSolution />
        <SectionPartners />
        <SectionApplications />
        <SectionTreinamento />
        <SectionQuestions />
      </div>
      <PageFooter />
    </div>
  );
}
